import { toQuery } from '@/utils/infrastructure';
import { request } from '@/utils/infrastructure/communication';
import _ from 'lodash';

export async function queryCurrent(changeCompany) {
  let user = localStorage.getItem('x-auth-user');
  if (user && !user.includes('useCache') && !changeCompany) return JSON.parse(user);

  const params = {
    select: 'id,isActive,fullName,names,lastNames,email,role,defaultLanguage',
    expand: {
      company: { select: 'id,name,commercialName,shortCode' },
      position: { select: 'id,name' },
      defaultEnvironment: { select: 'id,name' },
    },
  };

  user = await request('/user/info', { params: toQuery(params) });
  localStorage.setItem('x-auth-user', JSON.stringify(user));

  return user;
}

export async function queryNotices() {
  return request('/api/notices');
}

export async function recoveryPassword(email) {
  return request('/auth/recoveryPassword', {
    method: 'POST',
    data: { email },
  });
}

export async function updatePassword(data) {
  return request.post('/auth/resetPassword', { data });
}

export async function updateProfilePhoto(content) {
  return request('/account/updateProfilePhoto', {
    method: 'POST',
    data: { content },
  });
}
